export default "__VITE_ASSET__Dfu$KfZF__"